// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade[data-v-05027806] {\n  transition: all ease-in-out 0.2s;\n}\n.fade[data-v-05027806]:hover {\n  background-color: var(--v-active-base) !important;\n}\n", ""]);
// Exports
module.exports = exports;
